var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { chain, values, mapKeys, snakeCase } from 'lodash';
import { unparse } from 'papaparse';
import { Type } from 'class-transformer';
import { HttpBody } from './HttpBody';
import { $, apiFullURL, call, nullableItems, createCsvFile } from '../../helpers';
import * as Helper from '../../helpers';
var Collection = /** @class */ (function (_super) {
    __extends(Collection, _super);
    function Collection(type) {
        var _this = _super.call(this) || this;
        /**
         * If defined, then use this endpoint instead of the $endpoint resource
         */
        _this.endpoint = null;
        /**
         * Items of the collection
         * @type {Array}
         */
        _this.items = [];
        _this.type = type;
        return _this;
    }
    Object.defineProperty(Collection.prototype, "resource", {
        /**
         * Collection ClassObject of list
         */
        get: function () {
            return new this.type();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Call an API using Vue-Resource then serialize the response
     * @param promise Any call of VUE RESOURCE
     */
    Collection.prototype.call = function (promise) {
        return __awaiter(this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, call(this.type, promise)];
                    case 1:
                        resp = _a.sent();
                        this.items = resp.data;
                        return [2 /*return*/, resp];
                }
            });
        });
    };
    /**
     * Lists resource from WebServer
     * @param params
     * @param spinner
     */
    Collection.prototype.query = function (params, spinner) {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint, fetch;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = this.endpoint || this.resource.$endpoint;
                        fetch = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.call($.resource(apiFullURL(endpoint)).query(params))];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        }); }); };
                        return [4 /*yield*/, $.await.run(fetch, spinner || "query" + this.resource.$name)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Object.defineProperty(Collection.prototype, "schemas", {
        /**
         * Returns all schemas
         */
        get: function () {
            return this.items.map(function (item) { return item.$schema; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Collection.prototype, "schemasValues", {
        /**
         * Returns all schemas values from the matrix [row] [column]
         */
        get: function () {
            return this.items.map(function (item) { return values(item.$schema); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Collection.prototype, "header", {
        /**
         * Returns translated header
         */
        get: function () {
            var _this = this;
            return (chain(this.resource.$schema)
                // Hide hidden properties
                .pickBy(function (val) { return (val ? val.hidden !== true : true); })
                // Translate the keys
                .mapValues(function (val, key) { return $.t("classes." + _this.resource.$name + ".columns." + key); })
                // Get the result
                .value());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Collection.prototype, "headerValues", {
        /**
         * Returns translated header keys
         */
        get: function () {
            return values(this.header);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Collection.prototype, "data", {
        /**
         * Returns formatted data
         */
        get: function () {
            return this.renderSchema();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Collection.prototype, "textData", {
        /**
         * Returns formatted CSV data
         */
        get: function () {
            return this.renderSchema({ asText: true });
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Transform all schemas into data
     * @param options SchemaOptions
     */
    Collection.prototype.renderSchema = function (options) {
        if (options === void 0) { options = {}; }
        return this.items.map(function (item) { return item.renderSchema(options); });
    };
    /**
     * Downloads CSV file from its collection
     */
    Collection.prototype.downloadCsv = function (customTitle) {
        var _this = this;
        if (this.items.length <= 0)
            return;
        var title = $.t("classes." + this.resource.$name + ".title");
        var data = this.textData.map(function (schema) {
            // Translate the keys
            return mapKeys(schema, function (val, key) { return $.t("classes." + _this.resource.$name + ".columns." + key); });
        });
        createCsvFile(customTitle ? customTitle + ".csv" : snakeCase(title) + ".csv", unparse(data));
    };
    /**
     * Prepends a empty value into the resource list
     * @param placeholder
     */
    Collection.prototype.nullableItems = function (placeholder) {
        if (placeholder === void 0) { placeholder = null; }
        return nullableItems(this.items, placeholder);
    };
    /**
     * Get Resource by ID
     * @param id
     */
    Collection.prototype.get = function (id) {
        return Helper.getResource(this.items, id);
    };
    /**
     * Filter Resource by IDs
     * @param ids
     */
    Collection.prototype.getMany = function (ids) {
        return Helper.getManyResource(this.items, ids);
    };
    /**
     * Add a null item into the begin of the list
     * @param tag
     * @param useI18n
     */
    Collection.prototype.prependNull = function (tag, useI18n) {
        if (useI18n === void 0) { useI18n = true; }
        return this.prepend(0, useI18n ? $.t(tag) : tag);
    };
    /**
     * Add an item into the begin of the list
     * @param id
     * @param tag
     */
    Collection.prototype.prepend = function (id, tag) {
        Helper.prependResource(this.items, Helper.buildResource(id, tag));
        return this;
    };
    /**
     * Add an item into the end of the list
     * @param id
     * @param tag
     */
    Collection.prototype.append = function (id, tag) {
        Helper.appendResource(this.items, Helper.buildResource(id, tag));
        return this;
    };
    /**
     * Get the first item of the list
     */
    Collection.prototype.first = function () {
        return Helper.firstResource(this.items);
    };
    /**
     * Get the last item of the list
     */
    Collection.prototype.last = function () {
        return Helper.lastResource(this.items);
    };
    /**
     * Shuffle a list of Resource
     */
    Collection.prototype.shuffle = function () {
        this.items = Helper.shuffleResource(this.items);
        return this;
    };
    /**
     * Reverse a list of Resource
     */
    Collection.prototype.reverse = function () {
        this.items = Helper.reverseResource(this.items);
        return this;
    };
    /**
     * Add a Resource
     * @param id
     * @param tag
     * @param index
     */
    Collection.prototype.add = function (id, tag, index) {
        Helper.addResource(this.items, Helper.buildResource(id, tag), index);
    };
    /**
     * Remove a Resource by ID
     * @param id
     */
    Collection.prototype.remove = function (id) {
        Helper.removeResource(this.items, id);
    };
    __decorate([
        Type(function (options) { return options.newObject.type; }),
        __metadata("design:type", Array)
    ], Collection.prototype, "items", void 0);
    return Collection;
}(HttpBody));
export { Collection };
//# sourceMappingURL=Collection.js.map